import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, CircularProgress } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  deleting: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({ open, onClose, onConfirm, deleting }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!deleting) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("deepResearch.confirmations.deleteTitle")}</DialogTitle>
      <DialogContent>
        <Typography>{t("deepResearch.confirmations.deleteResearch")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button disableElevation onClick={handleClose} disabled={deleting} variant="outlined">
          {t("deepResearch.actions.cancel")}
        </Button>
        <Button
          disableElevation
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
        >
          {deleting ? t("deepResearch.confirmations.deleting") : t("deepResearch.confirmations.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
